import { Injectable, signal } from '@angular/core';

@Injectable({
    providedIn: 'root',
})
export class ThemeService {
    private readonly THEME_KEY = 'dentium-theme';
    isDarkMode = signal<boolean>(false);

    constructor() {
        this.initializeTheme();
    }

    toggleTheme() {
        this.isDarkMode.update((dark) => !dark);
        this.applyTheme();
        localStorage.setItem(this.THEME_KEY, this.isDarkMode() ? 'dark' : 'light');
    }

    private initializeTheme() {
        const savedTheme = localStorage.getItem(this.THEME_KEY);

        // Default is always light — only go dark if user explicitly chose it
        if (savedTheme === 'dark') {
            this.isDarkMode.set(true);
        } else {
            this.isDarkMode.set(false);
        }
        this.applyTheme();
    }

    private applyTheme() {
        if (this.isDarkMode()) {
            document.documentElement.classList.add('dark');
        } else {
            document.documentElement.classList.remove('dark');
        }
    }
}
